<div class="pl-2 relative text-xs text-grey-400">
  <!--Legend-->
  <ng-content select="[legend]"></ng-content>

  <!--Paginator-->
  <!--  <mat-paginator-->
  <!--    #paginator-->
  <!--    [pageIndex]="0"-->
  <!--    [pageSize]="pageSize"-->
  <!--    [pageSizeOptions]="pageSizeOptions"-->
  <!--    (page)="onChangePage($event)"-->
  <!--    [length]="config?.dataSourceLength || 0"-->
  <!--    class="bg-transparent"-->
  <!--  ></mat-paginator>-->
</div>
<div
  [ngClass]="{
    'overflow-x-auto': config?.enableScroll === true,
    'overflow-x-hidden': config?.enableScroll !== true
  }"
  class="w-full {{config?.cssWrapper}}"
>
  <table
    (cdkDropListDropped)="onListDrop($event)"
    (matSortChange)="sortData($event)"
    [cdkDropListDisabled]="!enableDragAndDrop"
    [dataSource]="dataSource"
    cdkDropList
    class="mat-elevation-z8"
    mat-table
    matSort
    matSortDirection="asc"
    matSortDisableClear
    multiTemplateDataRows
  >
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th *matHeaderCellDef class="pl-2" mat-header-cell>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="isAllSelect"
          [indeterminate]="!isAllSelected() && allSelectedRows.length > 0"
        >
        </mat-checkbox>
      </th>
      <td *matCellDef="let row; let index = dataIndex" class="pl-2" mat-cell>
        <mat-checkbox
          (change)="$event ? rowToggle(index, row) : null"
          (click)="$event.stopPropagation()"
          *ngIf="config?.allItemsSelectable || row.sourceTypeId === 2"
          [checked]="isSelected(row) !== -1 || isAllSelected()"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container
      *ngFor="let column of config?.columns"
      [matColumnDef]="column.columnDef"
      [sticky]="column.isSticky"
    >
      <th
        *matHeaderCellDef
        [disabled]="column.sort !== true"
        mat-header-cell
        mat-sort-header
      >
        <div class="flex flex-col pl-2">
          <span>{{
              column.needTranslate
                ? (column.header | transloco)
                : column.header
            }}</span>
          <span *ngIf="column.subheader">{{
              column.subheader | transloco
            }}</span>
        </div>
      </th>
      <div *ngIf="column.actions === undefined">
        <td *matCellDef="let row; let element" mat-cell>
          <div
            (click)="
              column.editable
                ? (element.editColumn = column.columnDef)
                : (element.editColumn = '');
              showEditCell(column, row)
            "
            *ngIf="element?.editColumn !== column.columnDef || !column.editable"
            class="flex items-center"
          >
            <div
              (click)="cellBoxChange(row, column.columnDef)"
              *ngIf="
                column.enableCellSelectBox && column.boxClass !== undefined
              "
              [class]="column.boxClass(row)"
              [innerHTML]="column.cell(row)"
              [ngClass]="{
                'border-2 border-black':
                  isCellBoxSelect(row, column.columnDef) > -1
              }"
            >

            </div>
            <div
              *ngIf="column.enableCellSelectBox !== true && column.paintHTML === undefined"
              [class]="column.customClass"
              [innerHTML]="column.needTranslate
                ? (column.cell(row) | transloco)
                : column.cell(row)"
              class="p-2"
            >
            </div>
            <div
              *ngIf="column.paintHTML !== undefined"
              [innerHTML]="column.paintHTML(row)"
            ></div>
          </div>
          <!-- Editable Column -->
          <div
            *ngIf="
              column.editable &&
              column.saveValue &&
              element.editColumn === column.columnDef
            "
          >
            <form
              (ngSubmit)="column.saveValue(model, row); element.editColumn = ''"
              [formGroup]="form"
              class="flex"
            >
              <formly-form
                [fields]="fields"
                [form]="form"
                [model]="model"
              ></formly-form>
              <button [disabled]="form.invalid" type="submit">
                <mat-icon class="cursor-pointer">check</mat-icon>
              </button>
              <button type="button">
                <mat-icon
                  (click)="element.editColumn = ''"
                  class="cursor-pointer"
                >close
                </mat-icon
                >
              </button>
            </form>
          </div>
        </td>
      </div>

      <!-- Icons Column -->
      <div *ngIf="column.actions !== undefined">
        <td *matCellDef="let row; let element" mat-cell>
          <div class="flex">
            <div
              *ngFor="let action of column.actions"
              class="flex items-center"
            >
              <mat-icon
                (click)="iconAction(action, row)"
                *ngIf="action.isDisplayed(row) && action.before"
                [class]="action.customClass"
                [matTooltip]="
                  action.tooltip === undefined
                    ? ''
                    : (action.tooltip | transloco)
                "
                [svgIcon]="action.icon"
              ></mat-icon>
            </div>
            <div [class]="column.customClass" class="pr-2">
              {{
                column.needTranslate
                  ? (column.cell(row) | transloco)
                  : column.cell(row)
              }}
            </div>
            <div
              *ngFor="let action of column.actions"
              class="flex items-center"
            >
              <mat-icon
                (click)="iconAction(action, row)"
                *ngIf="action.isDisplayed(row) && !action.before && !action.customIcon"
                [class]="action.customClass"
                [matTooltip]="
                  action.tooltip === undefined
                    ? ''
                    : (action.tooltip | transloco)
                "
                [svgIcon]="action.icon">
              </mat-icon>
              <i
                (click)="iconAction(action, row)"
                *ngIf="action.isDisplayed(row) && !action.before && action.customIcon"
                [class]="action.customClass + ' icon icon-' + action.icon"
                [matTooltip]="
                  action.tooltip === undefined
                    ? ''
                    : (action.tooltip | transloco)
                ">
              </i>
            </div>
          </div>
        </td>
      </div>
    </ng-container>

    <!-- Expandable rows -->
    <div *ngIf="config.rowDetails !== undefined">
      <ng-container matColumnDef="expandedDetail">
        <td
          *matCellDef="let row"
          [attr.colspan]="config.columns.length + 1"
          mat-cell
        >
          <div
            [@detailExpand]="row === expandedElement ? 'expanded' : 'collapsed'"
            [innerHTML]="config?.rowDetails(row)"
            class="table-element-detail"
          ></div>
        </td>
      </ng-container>
    </div>

    <tr *matHeaderRowDef="displayedColumns; sticky: true" mat-header-row></tr>
    <tr
      *matRowDef="let i = dataIndex; let row; columns: displayedColumns"
      cdkDrag
      cdkDragPreviewClass="hidden"
      mat-row
    ></tr>
    <div *ngIf="config.rowDetails !== undefined">
      <tr
        *matRowDef="let expandedElement; columns: ['expandedDetail']"
        class="table-detail-row"
        mat-row
      ></tr>
    </div>
  </table>
</div>
<!--<mat-paginator-->
<!--  [pageSize]="paginator.pageSize"-->
<!--  [pageSizeOptions]="paginator.pageSizeOptions"-->
<!--  (page)="syncPagers($event)"-->
<!--  [pageIndex]="paginator.pageIndex"-->
<!--  [length]="paginator.length"-->
<!--  class="bg-transparent"-->
<!--&gt;</mat-paginator>-->
<mat-paginator
  #paginator
  [length]="config?.dataSourceLength || 0"
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSize"
  class="col-span-5 flex justify-end bg-transparent "
></mat-paginator>
